import React from 'react';
import { MatchesView, Wrapper } from 'app/components/competitionModule/matches/commonStyles';
import MatchRowTeaserSkeleton from 'app/components/matchRow/teaser/MatchRowTeaserSkeleton';
import { StepperPlaceholder } from 'app/components/styles/swipeableViews/StepperPlaceholder';
import SectionHeading from 'app/components/competitionModule/common/SectionHeading';
import { Skeleton } from '@mui/material';
export default function MatchesSkeleton(_ref) {
  let {
    animation
  } = _ref;
  const matchTeaser = Array.from({
    length: 8
  }, (_, index) => /*#__PURE__*/React.createElement(MatchRowTeaserSkeleton, {
    key: "match-teaser-skeleton-".concat(index),
    animation: animation
  }));
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "MatchesSkeleton",
    "data-sentry-source-file": "MatchesSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(SectionHeading, {
    "data-sentry-element": "SectionHeading",
    "data-sentry-source-file": "MatchesSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    width: 120,
    animation: animation,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "MatchesSkeleton.tsx"
  })), /*#__PURE__*/React.createElement(MatchesView, {
    "data-sentry-element": "MatchesView",
    "data-sentry-source-file": "MatchesSkeleton.tsx"
  }, matchTeaser), /*#__PURE__*/React.createElement(StepperPlaceholder, {
    "data-sentry-element": "StepperPlaceholder",
    "data-sentry-source-file": "MatchesSkeleton.tsx"
  }));
}